import { Grid, Typography } from "@mui/material";
//import { FAQsData } from "@/utils/staticData/FAQsData";
import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";
//import CustomAccordion from "@/components/CustomAccordion";
import Section from "@/components/Section";
//import { accordionStyles } from "./styles";

const DealerFAQs = () => {
  const isMobile = useResponsive("down", "md");
  return (
    <Section
      pt={{ xs: 0, md: 8, lg: 12.5 }}
      pb={{ xs: 10, md: 12.5 }}
      bgColor={isMobile ? "white" : "background.default"}
    >
      <Grid container spacing={{ xs: 6 }}>
        <Grid item xs={12} md={6}>
          <Typography variant="h2" mb={{ xs: 2, md: 3 }}>
            FAQs
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color="text.secondary"
            mb={{ xs: 1.5, md: 3.5 }}
            maxWidth={{ xs: "auto", md: 450 }}
          >
            Everything you need to know about the product and billing. Can’t
            find the answer you’re looking for? Please chat to our friendly
            team.
          </Typography>

          <ButtonWithIcon
            label="Explore"
            IconComponent={ArrowRightIcon}
            isLink={true}
            to={`${ROUTES.faq}`}
          />
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <Box display="flex" flexDirection="column" sx={accordionStyles}>
            {FAQsData.map((faq) => (
              <CustomAccordion
                key={faq.id}
                label={faq.title}
                type="secondary"
                icon={null}
              >
                <Box dangerouslySetInnerHTML={{ __html: faq.data }} />
              </CustomAccordion>
            ))}
          </Box>
        </Grid> */}
      </Grid>
    </Section>
  );
};

export default DealerFAQs;
